/** This list is incomplete. Display statuses only */
export enum FirelightDisplayStatusEnum {
  complete = 'Complete',
  dataEntry = 'Data Entry',
  eDelivery = 'eDelivery',
  purged = 'Activity has been purged',
}
